import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchLibraryArgs } from '../api/types/marketplace.types';

import { fetchLibraryOrganizationCopies } from '../api/contentCopy.api';
import { fetchLibrary } from '../api/marketplace.api';

export const libraryQueryKeys = createQueryKeys('library', {
  fetchInfiniteLibrary: ({
    contentFilters,
    locale,
    tableFilters,
  }: FetchLibraryArgs) => ({
    queryFn: async (context: any) => {
      return fetchLibrary({
        ...context,
        contentFilters,
        locale,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      });
    },
    queryKey: [locale, contentFilters, tableFilters],
  }),
  // Where one Saved item already is. Keyed by the library row alone: the answer
  // is per acquisition and per caller, and the caller is the session.
  fetchOrganizationCopies: (libraryId: string) => ({
    queryFn: () => fetchLibraryOrganizationCopies(libraryId),
    queryKey: [libraryId],
  }),
});
